//@flow
import React from 'react';
import {makeStyles, Typography} from '@material-ui/core';
import {colors} from '../../assets/styles/colors';
import CustomButton from '../CustomButton/CustomButton';
import {ArrowBack} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  container: {
    minHeight: 56,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    color: colors.grey700,
    backgroundColor: colors.grey200,
    padding: theme.spacing(2),
    borderRadius: '.75rem',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  subtitle: {
    fontWeight: 600,
    fontSize: '1.125rem',
  },
}));

type Props = {
  name: string,
  icon?: React$Node,
  backPath?: string,
  onGoBack?: () => void,
};

export default function PageSubtitle(props: Props) {
  const {name, icon, backPath, onGoBack} = props;

  const classes = useStyles();

  return (
    <div className={classes.container}>
      {backPath && (
        <CustomButton to={backPath} onClick={onGoBack}>
          <ArrowBack />
        </CustomButton>
      )}
      {icon && icon}
      <Typography component={'span'} className={classes.subtitle}>
        {name}
      </Typography>
    </div>
  );
}
